import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const DisplayCustomCodeTaxCodeFragmentDoc = gql`
  fragment DisplayCustomCodeTaxCode on TaxCode {
    id
    code
    description
  }
` as unknown as DocumentNode<Types.DisplayCustomCodeTaxCodeFragment, unknown>
